import { render, staticRenderFns } from "./USP.vue?vue&type=template&id=136dc5af&scoped=true&"
import script from "./USP.vue?vue&type=script&lang=js&"
export * from "./USP.vue?vue&type=script&lang=js&"
import style0 from "./USP.vue?vue&type=style&index=0&id=136dc5af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136dc5af",
  null
  
)

export default component.exports